














































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { bus } from "../../main";
import { UserSignUpInfo } from "../../_models/userSignUpInfo";
import * as user from "../../_store/user.module";
import { userService } from "../../_services";

@Component
export default class UserCreate extends Vue {
  private userData: UserSignUpInfo;
  private nomeUtente: string;
  private cogomeUtente: string;
  private cod: string;
  private emailUtente: string;
  // private ruoloUtente: { ruolo: string; idRuolo: number };
  private ruoloUtente: number;
  private telefono1Utente: string;

  private nomeRules: [boolean | string];
  private cognomeRules: [boolean | string];
  private codRules: [boolean | string];
  private emailRules: [boolean | string];
  private ruoloRules: [boolean | string];
  private telRules: [boolean | string];

  private roleList: object;

  constructor() {
    super();
    this.userData = {
      ruoloUtente: 0,
      nomeUtente: "",
      cognomeUtente: "",
      telefonoUtente: "",
      username: "",
      emailUtente: "",
      cod: "",
      tipoSoggetto: 0,
      idEntità: 0
    };
    this.nomeUtente = "";
    this.cogomeUtente = "";
    this.cod = "";
    this.emailUtente = "";
    this.ruoloUtente = 0;
    this.telefono1Utente = "";
    this.nomeRules = [true];
    this.cognomeRules = [true];
    this.codRules = [true];
    this.emailRules = [true];
    this.ruoloRules = [true];
    this.telRules = [true];

    this.roleList = [];
  }

  @Watch("cod")
  onPivaChange(value: string) {
    this.cod = value.toUpperCase();
  }

  validazioneNome() {
    var valid: boolean = false;
    if (this.nomeUtente !== "") {
      valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.nomeUtente);
    }
    if (valid) {
      this.nomeRules = [true];
    } else if (this.nomeUtente === "") {
      this.nomeRules = ["Nome utente necessario"];
    } else {
      this.nomeRules = [
        "Nome utente deve essere compreso tra 2 e 100 caratteri"
      ];
    }
  }

  validazioneCognome() {
    var valid: boolean = false;
    if (this.cogomeUtente !== "") {
      valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.cogomeUtente);
    }
    if (valid) {
      this.cognomeRules = [true];
    } else if (this.cogomeUtente === "") {
      this.cognomeRules = ["Cognome utente necessario"];
    } else {
      this.cognomeRules = [
        "Cognome utente deve essere compreso tra 2 e 100 caratteri"
      ];
    }
  }

  validazioneCodiceFiscale() {
    var valid: boolean = false;
    if (this.cod !== "") {
      valid = /^[A-Z]{6}[A-Z0-9]{2}[A-Z][A-Z0-9]{2}[A-Z][A-Z0-9]{3}[A-Z]$/.test(
        this.cod
      );
    }
    if (valid) {
      this.codRules = [true];
    } else if (this.cod === "") {
      this.codRules = ["Codice fiscale necessario"];
    } else {
      this.codRules = ["Formato Codice fiscale errato"];
    }
  }

  validazioneEmail() {
    var valid: boolean = false;
    if (this.emailUtente !== "") {
      valid = /[a-zA-Z0-9._&-]+@[a-zA-Z0-9._&-]+\.[a-z]{2,}$/.test(
        this.emailUtente
      );
    }
    if (valid) {
      this.emailRules = [true];
    } else if (this.emailUtente === "") {
      this.emailRules = ["Email Utente necessaria"];
    } else {
      this.emailRules = ["Formato Email non corretto"];
    }
  }

  validazioneRuolo() {
    if (this.ruoloUtente === 0) {
      this.ruoloRules = ["Ruolo utente necessario"];
    } else {
      this.ruoloRules = [true];
    }
  }

  validazioneTel() {
    var valid: boolean = false;
    if (this.telefono1Utente !== "") {
      valid = /[0-9]{8,15}$/.test(this.telefono1Utente);
    }
    if (valid) {
      this.telRules = [true];
    } else if (this.telefono1Utente === "") {
      this.telRules = ["Telefono Utente necessario"];
    } else {
      this.telRules = ["Il numero di telefono non ha un formato corretto"];
    }
  }

  async executeTest() {
    this.validazioneNome();
    this.validazioneCognome();
    this.validazioneCodiceFiscale();
    this.validazioneEmail();
    this.validazioneRuolo();
    this.validazioneTel();
  }

  close() {
    this.nomeUtente = "";
    this.cogomeUtente = "";
    this.cod = "";
    this.emailUtente = "";
    this.ruoloUtente = 0;
    this.telefono1Utente = "";
    this.nomeRules = [true];
    this.cognomeRules = [true];
    this.codRules = [true];
    this.emailRules = [true];
    this.ruoloRules = [true];
    this.telRules = [true];
    bus.$emit("closeCreateDialog");
  }
  save() {
    this.executeTest().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        var userInfo = user.readUserInfo(this["$store"]);
        var username: string = "";
        if (userInfo.tipoSoggetto === 2) {
          var instituteInfo = user.readInstituteInfo(this["$store"]);
          var instituteId = instituteInfo.id;
          username = instituteId.toString() + "SC" + this.cod;
          this.userData = {
            ruoloUtente: this.ruoloUtente,
            nomeUtente: this.nomeUtente,
            cognomeUtente: this.cogomeUtente,
            telefonoUtente: this.telefono1Utente,
            emailUtente: this.emailUtente,
            username: username,
            cod: this.cod,
            tipoSoggetto: 2,
            idEntità: instituteId
          };
        } else if (userInfo.tipoSoggetto === 3) {
          var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
          var entepriseId = enterpriseInfo.idAzienda;
          username = entepriseId.toString() + "AZ" + this.cod;
          this.userData = {
            ruoloUtente: this.ruoloUtente,
            nomeUtente: this.nomeUtente,
            cognomeUtente: this.cogomeUtente,
            telefonoUtente: this.telefono1Utente,
            emailUtente: this.emailUtente,
            username: username,
            cod: this.cod,
            tipoSoggetto: 3,
            idEntità: entepriseId
          };
        }
        user
          .dispatchCreateUser(this["$store"], this.userData)
          .then(() => {
            this.close();
            bus.$emit("successfullOperation", "Utente creato con successo");
            bus.$emit("loadUserList");
          })
          .catch(error => {
            if (error.response.status === 401) {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            }
          });
      }
    });
  }
  created() {
    var userInfo = user.readUserInfo(this["$store"]);
    if (userInfo.tipoSoggetto === 2) {
      this.roleList = [
        { ruolo: "Tutor Settore", idRuolo: 5 },
        { ruolo: "Tutor Articolazione", idRuolo: 6 },
        { ruolo: "Tutor Formativo", idRuolo: 10 },
        { ruolo: "Osservatore", idRuolo: 11 }
      ];
    } else {
      this.roleList = [
        { ruolo: "Tutor Aziendale", idRuolo: 7 },
        { ruolo: "Referente HR Azienda", idRuolo: 8 },
        { ruolo: "Selezionatore", idRuolo: 9 }
      ];
    }
  }
}
